import styled from 'styled-components';

const Input = styled.input`
	padding: 16px 20px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);
	border: 0;

	color: #ffffff;
	font-family: GT Walsheim Pro;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	transition: all 0.3s ease;

	&::placeholder {
		color: rgba(255, 255, 255, 0.5);
	}

	&:hover {
		background: #ffffff;
		color: #000000;

		&::placeholder {
			color: rgba(0, 0, 0, 0.5);
		}
	}

	&:focus {
		outline: none;
	}
`;

export { Input };
